import { StateInterface } from 'client/Interfaces/StateInterface'
// typescript
import { QuotaTypes } from 'client/Interfaces/Subscription'
import {
  ISubscriptionFeatureItem,
  ISubscriptionFeatureList,
  SubscriptionFeatureCheckboxType,
} from 'client/Interfaces/Subscription/ISubscriptionFeatureList'
// misc
import { l } from 'client/Other/Translation'
import { setBaseClass } from 'client/utils'
import * as React from 'react'
import { useSelector } from 'react-redux'
import Checkmark from 'static/images/premiumPlans/checkmark/checkmark_green.svg'

import './FeatureList.scss'

interface FeatureCheckmark {
  feature: ISubscriptionFeatureItem
  billingCycle: ISubscriptionFeatureList
  allPlans
  selectedPlanName?: string
  processingPlanName?: string
}

const cls = setBaseClass('SubscriptionFeatureList')
const QuotaAmount = (props: FeatureCheckmark): JSX.Element => {
  const { feature, billingCycle, processingPlanName } = props
  const { id, amount } = feature
  const isInvoiceQuota = id === QuotaTypes.INVOICE
  const quota = useSelector(
    (state: StateInterface) =>
      state?.subscriptionManagement?.companySubscription?.subscription?.quotas?.find(
        (quota) => quota?.type === 'premium_invoice',
      )?.total,
  )

  if (amount === 30 && id !== 'premium_invoice') {
    return (
      <>
        <img
          className={cls({
            __checkmark: true,
            ...{
              '--checkmark-green': feature.checkboxStyle === SubscriptionFeatureCheckboxType.GREEN,
            },
          })}
          src={Checkmark}
        />
        <div className={cls('__amount')}>{l('subscription.customers_feature_label_starter')}</div>
      </>
    )
  }

  if (amount === -1) {
    return (
      <>
        <img
          className={cls({
            __checkmark: true,
            ...{
              '--checkmark-green': feature.checkboxStyle === SubscriptionFeatureCheckboxType.GREEN,
            },
          })}
          src={Checkmark}
        />
        <div className={cls('__amount')}>{l('subscription.customers_feature_label_pro_growth')}</div>
      </>
    )
  }

  if (amount === 5 && feature.id === 'limited_invoices_estimates') {
    return (
      <>
        <img
          className={cls({
            __checkmark: true,
            ...{
              '--checkmark-green': feature.checkboxStyle === SubscriptionFeatureCheckboxType.GREEN,
            },
          })}
          src={Checkmark}
        />
        <div className={cls('__amount')}>{feature.amount + ' ' + l(feature.translationKeyYear)}</div>
      </>
    )
  }

  if (amount === 5) {
    return (
      <>
        <img
          className={cls({
            __checkmark: true,
            ...{
              '--checkmark-green': feature.checkboxStyle === SubscriptionFeatureCheckboxType.GREEN,
            },
          })}
          src={Checkmark}
        />
        <div className={cls('__amount')}>{l('subscription.customers_feature_label_free')}</div>
      </>
    )
  }

  if (amount === 0) {
    return (
      <>
        <img
          className={cls({
            __checkmark: true,
            ...{
              '--checkmark-red': true,
            },
          })}
          src="../../../../../static/images/premiumPlans/checkmark/checkmark_cross.svg"
        />
        <div className={cls('__amount')}>{l('subscription.premium_invoices_free')}</div>
      </>
    )
  }

  if (!amount && (processingPlanName === 'plan.free' || processingPlanName === 'plan.none')) {
    return (
      <>
        <div className="SubscriptionFeatureList__text amount_invoice">
          <div className={cls('__blackMinus')}></div>
          <div className={cls('__amount')}>{l('subscription.premium_invoices_per_year_growth')}</div>
        </div>
      </>
    )
  }

  const getInvoiceLabel = () => {
    if (amount === 3 && billingCycle === 'year') {
      return (
        <>
          <img
            className={cls({
              __checkmark: true,
              ...{
                '--checkmark-green': feature.checkboxStyle === SubscriptionFeatureCheckboxType.GREEN,
              },
            })}
            src={Checkmark}
          />
          <div className={cls('__text_invoices_starter')}>{l('subscription.premium_invoices_per_year_starter')}</div>
        </>
      )
    }

    if (amount === 3 && billingCycle === 'month') {
      return (
        <>
          <img
            className={cls({
              __checkmark: true,
              ...{
                '--checkmark-green': feature.checkboxStyle === SubscriptionFeatureCheckboxType.GREEN,
              },
            })}
            src={Checkmark}
          />
          <div className={cls('__text_invoices_starter')}>{l('subscription.premium_invoices_per_month_starter')}</div>
        </>
      )
    }

    if (amount === 10 && billingCycle === 'month') {
      return (
        <>
          <img
            className={cls({
              __checkmark: true,
              ...{
                '--checkmark-green': feature.checkboxStyle === SubscriptionFeatureCheckboxType.GREEN,
              },
            })}
            src={Checkmark}
          />
          <div className={cls('__text_invoices_pro')}>{l('subscription.premium_invoices_per_month_pro')}</div>
        </>
      )
    }

    if (amount === 10 && billingCycle === 'year') {
      return (
        <>
          <img
            className={cls({
              __checkmark: true,
              ...{
                '--checkmark-green': feature.checkboxStyle === SubscriptionFeatureCheckboxType.GREEN,
              },
            })}
            src={Checkmark}
          />
          <div className={cls('__text_invoices_pro')}>{l('subscription.premium_invoices_per_year_pro')}</div>
        </>
      )
    }

    return (
      <>
        <img
          className={cls({
            __checkmark: true,
            ...{
              '--checkmark-green': feature.checkboxStyle === SubscriptionFeatureCheckboxType.GREEN,
            },
          })}
          src={Checkmark}
        />
        <div className={cls('__text_invoices_pro')}>
          {`${quota} ${l('subscription.premium_invoices_per_month_growth')}`}
        </div>
      </>
    )
  }
  const invoiceAmountClassName = isInvoiceQuota ? ' amount_invoice' : ''
  return <div className={`${cls('__text')}${invoiceAmountClassName}`}>{getInvoiceLabel()}</div>
}

export default QuotaAmount
